<div class="container-fluid">
    <div class="d-flex justify-content-between p-1">
        <h6>Vue élève</h6>
        <div class="p-2 text-center">
            <i class="fa fa-chevron-left fa-1x pe-1 text-white"></i>
            <a class="g-text-danger" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Mardi 20 Oct. <i class="fa fa-calendar"></i></a>
            <i class="fa fa-chevron-right fa-1x ps-1 text-white"></i>
        </div>
        <div class="d-flex">
            <select class="mx-1" id="">
                <option value="Trimestre 1">Trimestre 1</option>
                <option value="Trimestre 2">Trimestre 2</option>
            </select>
            <select class="mx-1" id="">
                <option value="list">6 eme</option>
                <option value="photo">5 eme</option>
            </select>
        </div>
    </div>

    <app-task-list-student-view ></app-task-list-student-view>
</div>